module.exports = __webpack_public_path__ + "static/img/311_TO8_2302_og.de4a4c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/311_TO8_2302_og.jpg
// module id = g93/
// module chunks = 0